app.initializers.add('justoverclock/og-meta-tag', () => {

});
